import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import OptOut from '@/components/optout';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const OptOutPage = () => {
	return (
		<Layout pageName="opt-out" title="Calm - Opt Out">
			<OptOut />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context, [InitRequest.DEVICE, InitRequest.USER]);

	return {
		props: {
			initialState,
		},
	};
};

export default OptOutPage;
